import { render, staticRenderFns } from "./CreatePost.vue?vue&type=template&id=7ab54480"
import script from "./CreatePost.vue?vue&type=script&lang=js"
export * from "./CreatePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports